import { render } from "./Onboard.vue?vue&type=template&id=378fdb0e&scoped=true&lang=pug"
import script from "./Onboard.vue?vue&type=script&lang=js"
export * from "./Onboard.vue?vue&type=script&lang=js"

import "./Onboard.vue?vue&type=style&index=0&id=378fdb0e&lang=scss"
import "./Onboard.vue?vue&type=style&index=1&id=378fdb0e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-378fdb0e"]])

export default __exports__